import * as React from "react";
import { useTranslation } from "react-i18next";
import CommonContainer from "../../../components/common/container/CommonContainer";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import useSnackbarAlert from '../../../utils/snackbarHandlers';
import { ViewContactDetails } from "../../../components";
import { LinearProgress } from "@mui/material";

const contactIntialData = {
  id: "",
  name: "",
  email: "",
  phoneNumber: "",
  subject: "",
  message: "",
  status: "",
  createdAt: "",
  updatedAt: ""
}

const ViewContact: React.FC = () => {
  const { t } = useTranslation('translation');
  const { id } = useParams();
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || 'http://18.217.95.31:8080';
  const { showErrorMessage } = useSnackbarAlert();
  const [contactUsData, setContactUsData] = React.useState<any>(contactIntialData);
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    setLoading(true);
    axios.get(`${apiBaseURL}/api/contact/fetchParticularContact?id=${id}`).then((res: any) => {
      if (res?.status === 200) {
        setContactUsData(res?.data?.contactInformation)
      } else setContactUsData({})
    })
      .catch((err: any) => showErrorMessage(err))
      .finally(() => setLoading(false))
  }, [])

  return (
    <CommonContainer title={t("viewContactPageTitle")} description={t("viewContactPageDescription")}>
      {loading ? <LinearProgress /> : <ViewContactDetails contactUsData={contactUsData} />}
    </CommonContainer>
  );
};

export default ViewContact;
